import { Link, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Typography } from '@glplus/glpweb-dsl';
import { categoryBySlug } from '../kit/content';
import { KitDisclaimer, KitDisclaimerLine } from '../kit/Disclaimer';
import { KitIcon } from '../kit/KitIcon';
import type { Lang } from '../kit/types';

export default function KitCategory() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language.startsWith('es') ? 'es' : 'en') as Lang;
  const { category = '' } = useParams();
  const c = categoryBySlug(category);
  if (!c) return <Alert severity="warning">{t('kit.notFound')}</Alert>;
  return (
    <Box data-testid="page-kit-category">
      <Typography component={Link} to="/kit" sx={{ color: '#1f7a3d', fontWeight: 600, fontSize: 13, textDecoration: 'none', display: 'inline-block', mb: 1.5 }}>{t('kit.back')}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
        <KitIcon category={c} size={44} />
        <Typography variant="h4" component="h1" sx={{ fontWeight: 800, color: '#1f2937', fontSize: { xs: '24px', md: '30px' } }}>{c.label[lang]}</Typography>
      </Box>
      <Typography sx={{ color: '#4b5563', mb: 2.5 }}>{c.blurb[lang]}</Typography>
      {c.half === 'business' ? <KitDisclaimer /> : <KitDisclaimerLine />}
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
        {c.guides.map((g) => (
          <Box key={g.slug} component={Link} to={`/kit/${c.slug}/${g.slug}`} sx={{ backgroundColor: '#fff', borderRadius: 2.5, borderTop: `3px solid ${c.accent}`, p: 2.5, textDecoration: 'none', boxShadow: '0 1px 2px rgba(16,24,40,0.06)' }}>
            <Typography sx={{ fontWeight: 800, fontSize: '16px', color: '#1f2937' }}>{g.body[lang].title}</Typography>
            <Typography sx={{ color: '#4b5563', fontSize: '14px', mt: 0.5 }}>{g.body[lang].summary}</Typography>
            <Typography sx={{ color: '#343F5B', fontWeight: 700, fontSize: '13px', mt: 1.5 }}>{t('kit.read')}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
